// src/components/Navbar.js
import React from "react";
import styled from "styled-components";
import { FaSearch } from "react-icons/fa";

// Import your logo
import truthLogo from "../assets/truth_logo.png";

const NavContainer = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #0F0F0F;
  padding: 1rem 2rem;
  border-bottom: 1px solid #00FF41;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  font-weight: bold;
  gap: 0.7rem;
`;

const LogoImage = styled.img`
  width: 50px;
  height: 50px;
  object-fit: contain;
`;

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  background: #121212;
  padding: 0.3rem 0.8rem;
  border-radius: 5px;

  input {
    background: transparent;
    border: none;
    outline: none;
    color: #00FF41;
    margin-left: 0.5rem;
    font-size: 0.95rem;
  }
`;

const MiddleText = styled.div`
  font-size: 1.2rem;
  color: #00FF41;
  font-weight: bold;
`;

const Navbar = () => {
  return (
    <NavContainer>
      {/* Left: Logo */}
      <Logo>
        <LogoImage src={truthLogo} alt="TruthAI Logo" />
        TruthAI
      </Logo>

      {/* Middle: Text */}
      <MiddleText>$TruthAI: 9t1evECofsFD8Kb7FooNV73fBj6dM8ejGa3CtVjspump</MiddleText>

      {/* Right: Search */}
      <SearchContainer>
        <FaSearch />
        <input type="text" placeholder="Search news..." />
      </SearchContainer>
    </NavContainer>
  );
};

export default Navbar;
